




























import Vue from 'vue';
import {default as mixins} from '../mixins/user';
import VueAvatar from '../avatar.vue';
import VueTimeago from '@/plugins/timeago';
import VueUserName from '@/components/user-name.vue';
import {Prop} from 'vue-property-decorator';
import Component from 'vue-class-component';
import {Message, MessageFolder} from '@/types/models';

Vue.use(VueTimeago);

@Component({
  mixins: [ mixins ],
  components: { 'vue-avatar': VueAvatar, 'vue-username': VueUserName }
})
export default class VueMessage extends Vue {
  @Prop()
  message!: Message;

  @Prop({default: false})
  last!: boolean;

  @Prop({default: false})
  clickableText!: boolean;

  SENTBOX = MessageFolder.sentbox;

  deleteMessage() {
    this.$confirm({
      message: 'Tej operacji nie będzie można cofnąć.',
      title: 'Usunąć tę wiadomość?',
      okLabel: 'Tak, usuń'
    })
    .then(() => this.$store.dispatch(`messages/${this.clickableText ? 'trash': 'remove' }`, this.message));
  }

  get isRead() {
    return this.message.folder !== MessageFolder.sentbox ? (this.message.read_at !== null) : true;
  }

  get excerpt() {
    return this.clickableText ? (this.message.excerpt ? this.message.excerpt : '(kliknij, aby przeczytać') : this.message.text
  }
}
